import {
    USERDEFINEDFIELDS_LOADING, USERDEFINEDFIELDS_DATA_SUCCESS, USERDEFINEDFIELDS_ADD_UDF_TO_TOUREVENT,
    UPDATE_USERDEFINEDFIELD, RESET_USERDEFINEDFIELDS, USERDEFINEDFIELDS_DATA_ERROR
} from "../actions/actionBookingUserDefinedFields";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "userdefinedfields";
const sessionKey2 = "udfIDNo";

const initialState = {
    bookingUDFs: loadState(sessionKey1, []),
    udfIDNo: loadState(sessionKey2, 0),
    loading: false,
    bookingUDFsError: ''
};

function reducerBookingUserDefinedFields(state = initialState, action) {

    switch (action.type) {

        case USERDEFINEDFIELDS_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case USERDEFINEDFIELDS_DATA_SUCCESS: {

            let udfID = 0;
            let oldBookingUdfs = JSON.parse(JSON.stringify(state.bookingUDFs));
            let bkngUdfs = JSON.parse(JSON.stringify(action.payload));


            if (oldBookingUdfs && oldBookingUdfs.length > 0) {
                udfID = JSON.parse(JSON.stringify(state.udfIDNo));

                oldBookingUdfs.map(oldBkng => {

                    if (bkngUdfs && bkngUdfs.length > 0 && bkngUdfs.filter(x => x.BookingTypeID === oldBkng.BookingTypeID).length < 1) {

                        let oldBooking = oldBookingUdfs.filter(x => x.BookingTypeID == oldBkng.BookingTypeID)[0];

                        if (oldBooking) {
                            bkngUdfs.push(oldBooking);
                        }
                    }
                });
            }

            bkngUdfs = bkngUdfs.filter(x => x.UDFCategories).map(booking => {

                if (oldBookingUdfs && oldBookingUdfs.length > 0 && oldBookingUdfs.filter(x => x.BookingTypeID === booking.BookingTypeID).length > 0) {
                    let oldBooking = oldBookingUdfs.filter(x => x.BookingTypeID == booking.BookingTypeID)[0];
                    return oldBooking;
                }

                booking.UDFCategories.map(udfCategories => {

                    let udfCat = { ...udfCategories };
                    udfCategories.UserDefinedFields = [];

                    if (udfCat.UserDefinedFields && udfCat.UserDefinedFields.length > 0) {
                        udfCat.UserDefinedFields.map(UDF => {

                            udfID = udfID + 1;
                            UDF.UDFID = udfID;
                            UDF.Value = '';
                            UDF.toureventID = 0;
                            udfCategories.UserDefinedFields.push(UDF);
                        });
                    }
                });

                return booking;
            });

            saveState(sessionKey1, bkngUdfs);
            saveState(sessionKey2, udfID);


            return {
                ...state,
                loading: false,
                bookingUDFs: bkngUdfs,
                udfIDNo: udfID,
                bookingUDFsError: ''
            };
        }

        case USERDEFINEDFIELDS_ADD_UDF_TO_TOUREVENT: {

            let bkngUdfs = JSON.parse(JSON.stringify(state.bookingUDFs));
            let booking = bkngUdfs.find(x => x.BookingTypeID === action.payload.bookingID);

            booking.UDFCategories = booking.UDFCategories.map(udfCategories => {

                if (udfCategories.UserDefinedFields.filter(x => x.toureventID === action.payload.toureventID).length < 1) {
                    udfCategories.UserDefinedFields.filter(x => x.toureventID === 0).map(UDF => {
                        var newUDF = Object.assign({}, UDF);
                        newUDF.toureventID = action.payload.toureventID;
                        udfCategories.UserDefinedFields.push(newUDF);
                    });
                }

                return udfCategories;
            });

            bkngUdfs = bkngUdfs.filter(x => x.BookingTypeID !== action.payload.bookingID);

            bkngUdfs.push(booking);

            saveState(sessionKey1, bkngUdfs);

            return {
                ...state,
                loading: false,
                bookingUDFs: bkngUdfs,
                bookingUDFsError: ''
            };
        }


        case UPDATE_USERDEFINEDFIELD: {

            let bkngUdfs = JSON.parse(JSON.stringify(state.bookingUDFs));
            let booking = bkngUdfs.find(x => x.BookingTypeID === action.payload.bookingID);

            booking.UDFCategories = booking.UDFCategories.map(udfCategories => {

                if (udfCategories.UDFCategoryName === action.payload.categoryName) {
                    udfCategories.UserDefinedFields.map(UDF => {

                        if (UDF.UDFID === action.payload.udfID && UDF.toureventID === action.payload.toureventID) {
                            UDF.Value = action.payload.value;
                        }
                    });
                }

                return udfCategories;
            });

            bkngUdfs = bkngUdfs.filter(x => x.BookingTypeID !== action.payload.bookingID);

            bkngUdfs.push(booking);

            saveState(sessionKey1, bkngUdfs);

            return {
                ...state,
                loading: false,
                bookingUDFs: bkngUdfs,
                bookingUDFsError: ''
            };
        }

        case USERDEFINEDFIELDS_DATA_ERROR: {

            saveState(sessionKey1, action.payload);

            return {
                ...state,
                loading: false,
                bookingUDFsError: action.error
            }
        }

        case RESET_USERDEFINEDFIELDS: {

            saveState(sessionKey1, []);
            saveState(sessionKey2, 0);

            return {
                ...state,
                loading: false,
                udfIDNo: 0,
                bookingUDFs: [],
                bookingUDFsError: ''
            };
        }

        default: {
            return state;
        }
    }
}

export default reducerBookingUserDefinedFields;